export default function removeDuplicates(data){
  
    var a = data.reduce((acc, current) => {
      
          const x = acc.find(item => item.nome === current.nome);
          if (!x) {
            return acc.concat([current]);
          } else {
            return acc;
          }
        }, [])
        return a
  }